import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import MainApp from './pages/MainApp';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import {ThemeProvider} from '@mui/material/styles';
import theme from './theme';
import QrGen from "./pages/QrGen";

function App() {
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                    <Route path="/qr-code-generator" element={<QrGen />} />
                    <Route path="/" element={<MainApp />} />

                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App;
